module.exports = __webpack_public_path__ + "static/media/trading.d42e12ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/trading.svg
// module id = 1162
// module chunks = 0